__turbopack_context__.v({
  "root": "MenuItemLabel-module__KEBobW__root",
});
